import { useModal } from '@ebay/nice-modal-react';
import { Box, Stack } from '@mui/material';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography, SizingMultiplier } from '@ocx/ui';
import { ModalDrawer } from '@ocx/ui-modals';

import { useCompleteEmailActionSheetController } from './complete-email-action-sheet.controller.hook';
import { messages } from './complete-email-action-sheet.messages';
import { CompleteEmailActionSheetProps } from './complete-email-action-sheet.types';
import { CompleteEmailActionSheetView } from './complete-email-action-sheet.view';

export const CompleteEmailActionSheetController = (props: CompleteEmailActionSheetProps) => {
  const { visible, hide, remove } = useModal();
  const { onCompleted } = props;

  const handleCompleted = useCallback(() => {
    hide();
    onCompleted?.();
  }, [hide, onCompleted]);
  const { handleUpdateEmail } = useCompleteEmailActionSheetController({ onCompleted: handleCompleted });

  return (
    <ModalDrawer open={visible} onClose={hide} onExited={remove}>
      <Box p={SizingMultiplier.lg}>
        <Stack mb={SizingMultiplier.md}>
          <Typography align="center" variant="h5" gutterBottom>
            <FormattedMessage {...messages['complete-email-action-sheet:title']} />
          </Typography>
          <Typography align="center" variant="body2" color="textSecondary">
            <FormattedMessage {...messages['complete-email-action-sheet:description']} />
          </Typography>
        </Stack>
        <CompleteEmailActionSheetView onSubmit={handleUpdateEmail} />
      </Box>
    </ModalDrawer>
  );
};
